<template>
  <div class="container" v-loading="is_loading">
    <!-- 模考大赛 -->
    <div class="content_wrap" v-if="all_mock_list.length">
      <div class="tit_wrap">
        <div class="text">{{ $t("page_home.mock_tit") }}</div>
        <div class="flex">
          <a
            class="mock_record_btn"
            :href="`${ke_host}mine/mock_record`"
            target="_blank"
            @click="handletoLogin"
          >
            <img src="@/assets/home/mock_record.png" />我的模考记录
          </a>
          <router-link
            to="/list/1"
            class="more"
            target="_blank"
            style="margin-left: 20px"
          >
            查看更多 <i class="el-icon-arrow-right"></i>
          </router-link>
        </div>
      </div>
      <div class="cont_wrap">
        <div class="mock_wrap">
          <div class="nav_type">
            <!-- <div class="nav_ul">
              <div
                :class="['li', item.id == filter_id ? 'on' : '']"
                v-for="(item, index) in filter_list"
                :key="index"
                @click="handleChangeFilter(item.id)"
              >
                <span></span>{{ item.name }}
              </div>
            </div> -->
          </div>
          <div class="mock_time_wrap">
            <template v-if="mock_list.length">
              <div class="time_wrap">
                <div class="time_ul">
                  <div
                    v-for="(item, index) in mock_list"
                    :class="['time_li', time_index == index ? 'on' : '']"
                    :key="index"
                    @click="handleChangeTime(index)"
                  >
                    {{ item.left_mock_time }}
                  </div>
                </div>
              </div>
              <div class="mock_list_wrap" @scroll="scrollEvent">
                <template v-if="mock_list.length">
                  <template v-for="(item, index) in mock_list">
                    <div class="mock_ul" :key="index">
                      <div
                        class="mock_li"
                        v-for="(mock, mock_i) in item.mock"
                        :key="mock_i"
                      >
                        <div class="mock_title">
                          <b>{{ mock.mock_title }}</b>
                        </div>
                        <div class="mock_time">
                          <img src="@/assets/home/home_time.png" alt="" />
                          <span>{{ item.mock_time }}</span>
                        </div>
                        <div class="mock_child">
                          <div class="mock_score" v-if="mock.checkflag">
                            <b>{{ mock.mock_score }}</b
                            >分
                          </div>
                          <div class="child">
                            <div
                              class="child_li"
                              v-for="(child, child_i) in mock.child"
                              :key="child_i"
                            >
                              <span
                                class="child_alis"
                                :title="child.child_alias"
                                >{{ child.child_alias }}</span
                              >
                              <div class="r">
                                <span class="time"
                                  >{{
                                    child.time_stage ? child.time_stage : ""
                                  }}
                                  {{ child.exam_time }}</span
                                >

                                <template v-if="mock.mock_is_sign == 1">
                                  <span
                                    class="status blue"
                                    v-if="child.child_status == 1"
                                    >待开考</span
                                  >
                                  <span
                                    class="status red"
                                    v-else-if="child.child_status == 2"
                                    >考试中</span
                                  >
                                  <template v-else-if="child.child_status == 3">
                                    <span
                                      class="status"
                                      v-if="
                                        child.total_score ||
                                        child.total_score == 0
                                      "
                                      >{{ child.total_score }}分</span
                                    >
                                    <span class="status" v-else>未考</span>
                                  </template>
                                </template>
                                <template v-else>
                                  <span class="status">未报名</span></template
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mock_bot">
                          <div class="count">
                            已报名 {{ mock.mock_count }}人
                          </div>
                          <div class="btn">
                            <router-link
                              :to="'/mock_intro/' + mock.id"
                              :class="['to_exam']"
                              target="_blank"
                            >
                              {{
                                mock.mock_is_sign == 1 ? "去考场" : "报名详情"
                              }}
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </template>
            <div v-else class="nocontent_wrap">
              <nocontent />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 历年真题 -->
    <div v-if="real_list.length" class="content_wrap">
      <div class="tit_wrap">
        <div class="text">历年真题</div>
        <router-link to="/list/2" class="more" target="_blank">
          查看更多 <i class="el-icon-arrow-right"></i>
        </router-link>
      </div>
      <div class="cont_wrap cont_wrap_real clearfloat">
        <template v-for="(item, index) in real_list">
          <real_item :item="item" :key="index" />
        </template>
      </div>
    </div>
    <!-- 知识点练习 -->
    <div class="content_wrap">
      <div class="tit_wrap">
        <div class="text">知识点练习</div>
        <router-link to="/list/3" class="more" target="_blank">
          查看更多 <i class="el-icon-arrow-right"></i>
        </router-link>
      </div>
      <div class="cont_wrap cont_wrap_knowledge clearfloat">
        <div class="l">
          <div class="filters_input">
            <el-form :inline="true" ref="form" :model="form" label-width="80px">
              <el-form-item label="专业：">
                <el-select
                  v-model="form.major"
                  placeholder="请选择专业"
                  size="medium"
                  @change="handleChangeMajor"
                >
                  <el-option
                    v-for="(value, key) in major"
                    :key="key"
                    :label="value"
                    :value="key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="科目：">
                <el-select
                  v-model="form.subject"
                  placeholder="请选择科目"
                  size="medium"
                  @change="handleChangeSubject"
                >
                  <el-option
                    v-for="(value, key) in subject"
                    :key="key"
                    :label="value"
                    :value="key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <knowledge
            v-if="knowledge_isshow"
            :major_id="form.major"
            :subject_id="form.subject"
            :is_login="is_login"
            tag="home"
          />
        </div>
        <div class="r">
          <div class="wrong_book">
            <div class="tit_wrap tit_wrap2">
              <!-- （{{ wrong_book.length }}） -->
              <div class="text flex">
                错题本 <img src="@/assets/home/NEW.png" alt="" />
              </div>
              <router-link to="/list/5" class="more" target="_blank">
                全部 <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
          </div>
          <div class="knowledge_record">
            <div class="tit_wrap tit_wrap2">
              <!-- （{{ knowledge_record_total_count }}） -->
              <div class="text flex">
                练习记录 <img src="@/assets/home/NEW.png" alt="" />
              </div>
              <router-link to="/list/4" class="more" target="_blank">
                全部 <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
            <div class="record_wrap">
              <practice_record :num="3" @getTotalCount="getTotalCount" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 模考 考试规则弹窗 -->
    <el-dialog title="考试说明" :visible.sync="dialogVisibleRule">
      <div>
        <pre class="dialog_rule taj" v-html="mock_rule"></pre>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/request/api";
import real_item from "@/components/real_item.vue";
import knowledge from "@/components/knowledge.vue";
import practice_record from "@/views/list/record_list.vue";
import { mapActions } from "vuex";
import { ke_host } from "@/request/config";
import nocontent from "@/components/nocontent.vue";
import { toLogin } from "@/assets/js/cookie.js";
export default {
  name: "home",
  components: {
    real_item,
    knowledge,
    practice_record,
    nocontent,
  },
  data() {
    return {
      all_mock_list: [],
      mock_list: [],
      default_mock_index: 0,

      real_list: [],

      form: {
        major: "",
        subject: "",
      },
      major: [],
      subject: [],

      knowledge_isshow: false, // 知识点组件是否显示

      dialogVisibleRule: false,
      mock_rule: "",

      is_loading: true,

      is_login: false,

      knowledge_record_total_count: 0,

      filter_id: 0,
      filter_list: [
        {
          name: "全部模考",
          id: 0,
        },
        {
          name: "管综/英语模考",
          id: 1,
        },
        // {
        //   name: "政治/英语/数学模考",
        //   id: 2,
        // },
        // {
        //   name: "专业课",
        //   id: 3,
        // },
        {
          name: "政治/英语/经综模考",
          id: 4,
        },
      ],
      time_index: 0,
      ke_host: "",
    };
  },
  mounted() {},
  async created() {
    this.ke_host = ke_host;
    this.getData();
    this.getMajor();
    // this.ceshi();
    this.is_login = await this.islogin();
    if (this.is_login) {
      this.mock_home_user();
    }
  },
  methods: {
    ...mapActions(["setUserAndState"]),
    // async ceshi() {
    //   const res = await api.ceshi();
    // },
    async getData() {
      try {
        const res = await api.home();
        if (res.code == 0) {
          let { mock_list, real_list } = res.result;
          this.mock_list = mock_list;
          this.real_list = real_list;
          this.all_mock_list = mock_list;
          this.is_loading = false;
        }
      } catch (e) {
        console.log(e);
        this.is_loading = false;
      }
    },
    handleChangeDefault(index) {
      this.default_mock_index = index;
    },
    toList(type) {
      this.$router.push("/list/" + type);
    },
    handleExamTip(rule) {
      this.mock_rule = rule;
      this.dialogVisibleRule = true;
    },
    mock_home_user() {
      api.mock_home_user().then((res) => {
        if (res.code == 0) {
          let user_record = res.result.time;
          if (user_record.length) {
            this.mock_list.forEach((item_time) => {
              user_record.forEach((items_time) => {
                if (item_time.mock_time == items_time.mock_time) {
                  item_time.mock.forEach((item_mock) => {
                    items_time.mock.forEach((items_mock) => {
                      if (item_mock.id == items_mock.id) {
                        this.$set(
                          item_mock,
                          "mock_is_sign",
                          items_mock.mock_is_sign
                        );
                        let mock_score = 0;
                        let check_flag = false; // 是否交卷
                        item_mock.child.forEach((item_child) => {
                          items_mock.child.forEach((items_child) => {
                            if (item_child.id == items_child.id) {
                              this.$set(
                                item_child,
                                "total_score",
                                items_child.total_score
                              );
                              mock_score += items_child.total_score
                                ? items_child.total_score
                                : 0;
                              if (
                                items_child.total_score ||
                                items_child.total_score == 0
                              ) {
                                check_flag = true;
                              }
                            }
                          });
                        });
                        this.$set(item_mock, "mock_score", mock_score);
                        this.$set(item_mock, "checkflag", check_flag);
                      }
                    });
                  });
                }
              });
            });
          }
        }
      });
    },
    // 知识点练习 -----------------------------start
    async getMajor(major_id) {
      try {
        const res = await api.major({
          major_id: major_id,
        });
        if (res.code == 0) {
          let { major, subject } = res.result;
          if (!major_id) {
            this.major = major;
            let major_arr = Object.keys(major);
            this.form.major = major_arr[0];
          }

          this.subject = subject;
          let subject_arr = Object.keys(subject);
          this.form.subject = subject_arr[0];

          this.knowledge_isshow = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleChangeMajor(val) {
      if (val) {
        this.getMajor(val);
      }
    },
    handleChangeSubject(val) {
      if (val) {
        this.form.subject = val;
      }
    },
    getTotalCount(num) {
      this.knowledge_record_total_count = num;
    },
    // 知识点练习 -----------------------------end
    islogin() {
      this.setUserAndState();
      const { logined } = this.$store.state;
      if (logined) {
        return true;
      } else {
        return false;
      }
    },
    handleChangeFilter(id) {
      this.filter_id = id;
      this.default_mock_index = 0;
      if (id == 0) {
        this.mock_list = this.all_mock_list;
      } else {
        let arr = [];
        this.all_mock_list.forEach((item_time) => {
          let item_time_obj = {
            count: item_time.count,
            left_mock_time: item_time.left_mock_time,
            mock: [],
            mock_time: item_time.mock_time,
          };
          item_time.mock.forEach((m) => {
            if (m.project_type == id) {
              item_time_obj.mock.push(m);
            }
          });
          if (item_time_obj.mock.length > 0) {
            arr.push(item_time_obj);
          }
        });
        this.mock_list = arr;
      }
    },
    handleChangeTime(index) {
      this.time_index = index;
      let contents = document.querySelectorAll(".mock_ul");
      contents[index].scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    },
    scrollEvent(e) {
      const { mock_list } = this;
      let contents = document.querySelectorAll(".mock_ul");
      let nowTop = e.target.scrollTop; // 滚动条目前的滚动距离
      let firstTop = contents[0].offsetTop; // 第一个章节的顶部位置
      let idx = null;
      try {
        // forEach循环只能通过抛出异常的方式终止
        mock_list.forEach((section, index) => {
          let contentTop = contents[index].offsetTop; // 第index个章节的顶部位置
          let scrollDistance = contentTop - firstTop; // 从第一个章节到第index个章节的滚动距离
          if (nowTop < scrollDistance) {
            // 滚动条已滚动的距离少于第index个章节需要的滚动距离，说明当前正文处于第(index-1)的章节
            idx = Math.max(0, index - 1);
            throw new Error(`find section:${this.time_index}`);
          }
        });
      } catch (e) {}
      // 滚动到最后一章（该章节高度超过正文容器）时，滚动条的滚动距离超过所有章节需要的滚动距离
      this.time_index = idx === null ? mock_list.length - 1 : idx;
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight ===
        e.srcElement.scrollHeight
      ) {
        // 滚动条触底，处于最后一章（消除该章节高度低于正文容器时始终定位在倒数第二章的情况）
        this.time_index = mock_list.length - 1;
      }
    },
    handletoLogin() {
      if (this.$store.state.logined) {
        return;
      } else {
        toLogin(location.href);
      }
    },
  },
  filters: {
    filters_mock_status(status) {
      if (status == 1) {
        return "正在报名";
      } else if (status == 2) {
        return "考试中";
      } else {
        return "考试结束";
      }
    },
    filters_mock_status1(status) {
      if (status == 1) {
        return "报名中";
      } else if (status == 2) {
        return "考试中";
      } else {
        return "已结束";
      }
    },
  },
};
</script>

<style scoped lang="less">
.container {
  padding-bottom: 40px;
  position: relative;
}
.tit_wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 49px 0 20px;
  .text {
    font-size: 28px;
    font-weight: bold;
    color: #1f1f1f;
  }
  .more {
    font-size: 18px;
    color: #999999;
  }
  .mock_record_btn {
    width: 182px;
    height: 40px;
    background: #bffb4f;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
  }
}
.tit_wrap2 {
  padding: 30px 0;
  .text {
    font-size: 18px;
    img {
      margin-left: 10px;
    }
  }
}
.date_wrap {
  display: flex;
}
.sign {
  display: inline-block;
  width: 4px;
  background: #fb9530;
  border-radius: 2px;
}
.date_b {
  width: 180px;
  height: 116px;
  background: #ffffff;
  border-radius: 8px;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  padding: 15px 0 15px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  margin-right: 24px;
  p {
    font-size: 14px;
    font-weight: 400;
    color: #4f5666;
  }
  .sign {
    height: 16px;
    margin-right: 5px;
  }
  .time {
    display: flex;
    align-items: center;
    b {
      font-size: 18px;
      color: #1f1f1f;
      margin-right: 9px;
    }
  }
  .status {
    margin-top: 3px;
  }
  .countdown {
    position: absolute;
    right: 20px;
    bottom: 15px;
    .today {
      width: 56px;
      height: 40px;
      border-radius: 4px;
      background: #f96158;
      text-align: center;
      line-height: 40px;
      color: #fff;
    }
    .distance {
      width: 56px;
      height: 40px;
      background: url("@/assets/home/distance.png") no-repeat;
      line-height: 40px;
      b {
        display: inline-block;
        width: 72%;
        text-align: center;
        color: #f2230c;
        font-size: 18px;
      }
    }
  }
}

.date_b.on {
  border: 2px solid #479dff;
}
.date_b:nth-child(6n) {
  margin-right: 0;
}
.f16_4F5666 {
  font-size: 16px;
  color: #4f5666;
}
.line {
  border-bottom: 1px solid #e9e9e9;
  margin: 25px 0;
}
.mock {
  height: 192px;
  background: #fff;
  border-radius: 8px;
  margin-top: 24px;
  padding: 30px;
  box-sizing: border-box;
  .mock_t,
  .mock_b,
  .l,
  .r {
    display: flex;
    align-items: center;
  }
  .sign {
    height: 55px;
    margin-right: 10px;
  }
  .title_subject {
    height: 62px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-size: 20px;
      color: #1f1f1f;
    }
    .subject {
      margin-right: 30px;
    }
  }
  .mock_b {
    justify-content: space-between;
    .l p {
      margin-right: 40px;
      img {
        margin-right: 10px;
      }
    }
    .r .status {
      margin-right: 40px;
    }
  }
}
.living {
  width: 16px;
  margin-right: 10px;
}
.toDetail {
  width: 110px;
  height: 36px;
  background: #479dff;
  border-radius: 18px;
  text-align: center;
  line-height: 36px;
  font-size: 16px;
  color: #fff;
}
.toDetail.red {
  background: #f96158;
}
.mock_rule {
  cursor: pointer;
}
.dialog_rule {
  all: initial; /*清除继承样式*/
  display: block; /*设置布局流，避免换行导致的错误布局*/
  white-space: pre-line; /*保留换行符，设置溢出换行*/
  font-size: 16px; /*设置字号*/
  line-height: 28px;
}
.cont_wrap_knowledge {
  .l,
  .r {
    border-radius: 8px;
    box-sizing: border-box;
  }
  .l {
    width: 792px;
    float: left;
    padding: 30px 10px;
    background: #ffffff;
  }
  .r {
    width: 384px;
    float: right;
  }
}
.el-form-item {
  margin-bottom: 15px;
}
/deep/.el-input input {
  width: 200px;
  font-size: 16px;
  color: #1f1f1f;
}
/deep/.el-form-item__label {
  font-size: 16px;
  color: #4f5666;
}
// 练习记录----------------- start
.knowledge_record {
  padding: 0 30px;
  background: #ffffff;
  margin-top: 24px;
}

.record_wrap {
  min-height: 300px;
  position: relative;
  /deep/.record_wrap {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-top: 1px solid #e9e9e9;
    padding: 0;

    .msg {
      font-size: 14px;
      color: #4f5666;
      padding-top: 8px;
      span {
        color: #479dff;
      }
    }
  }
  /deep/.record_wrap:hover {
    background: #fff;
  }
  /deep/a:last-child .record_wrap {
    border-bottom: 1px solid #e9e9e9;
  }
  .container {
    width: 100%;
    min-height: 300px;
    // padding-bottom: 0;
  }
  /deep/.record_content {
    padding: 0 !important;
  }
  /deep/.l {
    width: 100%;
  }
  /deep/.name {
    font-weight: normal !important ;
  }
  /deep/.content_wrap {
    margin-top: 0;
  }
}
// 练习记录----------------- end

// 错题本----------------- start
.wrong_book {
  padding: 0 30px;
  background: #ffffff;
}
// 错题本----------------- end

// 新版模考部分----------------- start
.mock_wrap {
  width: 1200px;
  height: 560px;
  display: flex;
  .nav_type {
    width: 244px;
    height: 100%;
    background: url(@/assets/home/mock_wrap_bg.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .nav_ul {
      width: 204px;
      position: absolute;
      top: 135px;
      left: 20px;
      .li {
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;
        color: #fff;
        margin-bottom: 20px;
        cursor: pointer;
        span {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 10px;
          background: #fff;
          box-sizing: border-box;
        }
      }
      .li.on {
        background: #ffffff;
        border-radius: 500px 500px 500px 500px;
        color: #198cff;
        span {
          border: 2px solid #6fd3ff;
        }
      }
      .li:last-child {
        margin-bottom: 0;
      }
    }
  }
  .mock_time_wrap {
    flex: 1;
    background: #eaecf3;
    border-radius: 0px 8px 8px 0px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    .time_wrap {
      .time_ul {
        .time_li {
          width: 120px;
          height: 60px;
          border-right: 3px solid rgba(21, 21, 21, 0.2);
          font-size: 15px;
          color: rgba(21, 21, 21, 0.2);
          text-align: center;
          line-height: 60px;
          cursor: pointer;
        }
        .time_li.on {
          border-right: 3px solid #151515;
          color: #151515;
        }
      }
    }
    .mock_list_wrap {
      flex: 1;
      height: 100%;
      padding: 10px 0 0 44px;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;
      .mock_ul {
        margin-top: 10px;
      }
      .mock_ul:first-child {
        margin-top: 0;
      }
      .mock_li {
        width: 762px;
        background: #ffffff;
        border-radius: 8px;
        padding: 20px 30px;
        box-sizing: border-box;
        margin-top: 10px;
        .mock_time {
          font-size: 14px;
          color: #198cff;
          display: flex;
          align-items: center;
          margin: 10px 0;
          img {
            margin-right: 8px;
          }
        }
        .mock_child {
          background: linear-gradient(
            180deg,
            #f7f9fa 0%,
            rgba(247, 249, 250, 0) 100%
          );
          border-radius: 8px 8px 8px 8px;
          padding: 0 10px;
          .mock_score {
            font-size: 14px;
            color: #151515;
            padding: 10px 0;
            border-bottom: 1px solid #e1e1e1;
          }
          .child {
            padding-top: 10px;
            display: flex;
            flex-wrap: wrap;
            .child_li {
              width: 50%;
              padding-bottom: 10px;
              font-size: 14px;
              display: flex;
              .child_alis {
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .r {
                width: 190px;
                display: flex;
                .time {
                  color: #666666;
                  padding-left: 22px;
                }
                .status {
                  flex: 1;
                  color: #666666;
                  padding-left: 15px;
                }
                .status.blue {
                  color: #198cff;
                }
                .status.red {
                  color: #ec652b;
                }
              }
            }
            .child_li:nth-child(even) {
              padding-left: 50px;
              box-sizing: border-box;
            }
            .child_li:nth-child(odd) {
              padding-right: 50px;
              box-sizing: border-box;
            }
          }
        }
        .mock_bot {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          .count {
            font-size: 14px;
            color: #9e9e9e;
          }
          .btn .to_exam {
            display: inline-block;
            width: 180px;
            height: 30px;
            background: #198cff;
            border-radius: 100px 100px 100px 100px;
            line-height: 30px;
            font-size: 14px;
            color: #fff;
            text-align: center;
          }
        }
      }
      .mock_li:first-child {
        margin-top: 0;
      }
    }
  }
}

/* 自定义整个滚动条 */
.mock_list_wrap::-webkit-scrollbar {
  width: 8px; /* 设置滚动条的宽度 */
}

/* 自定义滚动条轨道 */
.mock_list_wrap::-webkit-scrollbar-track {
  background: #eaecf3; /* 设置轨道的背景颜色 */
}

/* 自定义滚动条的滑块（thumb） */
.mock_list_wrap::-webkit-scrollbar-thumb {
  background: #c1c1c1; /* 设置滑块的背景颜色 */
  border-radius: 100px;
}

/* 当滑块悬停或活动时，可以添加更多样式 */
.mock_list_wrap::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1; /* 设置滑块在悬停状态下的背景颜色 */
}

.nocontent_wrap {
  width: 100%;
  height: 100%;
  position: relative;
}
// 模考模考部分----------------- end
</style>
